import { WA_IS_E2E } from "@ng-web-apis/platform";


import { Component, Inject, ElementRef, OnInit, Renderer2, AfterViewInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, map, of, takeWhile, timer } from 'rxjs';
import { loggedInUserViewModel, userRoleDTO } from 'src/app/all-modules/admin/models/user-management/user_models';
import { UserManagementService } from 'src/app/all-modules/admin/services/user-management/user-management.service';
import { InConfiguration } from 'src/app/all-modules/core/models/config.interface';
import { UserLoginReponse } from 'src/app/all-modules/core/models/user';
import { AuthService } from 'src/app/all-modules/core/service/auth.service';
import { LanguageService } from 'src/app/all-modules/core/service/language.service';
import { RightSidebarService } from 'src/app/all-modules/core/service/rightsidebar.service';
import { switchRoleReq, switchRoleResponse } from 'src/app/all-modules/shared/common-model/common.model';
import { MESSAGE_CATEGORY_CONSTATNS, MESSAGE_CONSTATNS, APP_CONSTANTS } from 'src/app/all-modules/shared/constants/constant';
import { CommonToastService } from 'src/app/all-modules/shared/services/common-toast.service';
import { CommonService } from 'src/app/all-modules/shared/services/common.service';
import { SpinnerService } from 'src/app/all-modules/shared/services/spinner.service';
import { ConfigService } from 'src/app/config/config.service';
import { ShowManagementService } from 'src/app/all-modules/admin/services/show-management/show-management.service';


interface Notifications {
  message: string;
  time: string;
  icon: string;
  color: string;
  status: string;
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public config!: InConfiguration;
  isNavbarCollapsed = true;
  flagvalue: string | string[] | undefined;
  countryName: string | string[] = [];
  langStoreValue?: string;
  defaultFlag?: string;
  isOpenSidebar?: boolean;
  docElement: HTMLElement | undefined;
  isFullScreen = false;
  currentValue!: any;
  public timerInterval: any;
  displays: any;
  isChangePasswordDialog = false;
  resetPasswordForm!: FormGroup;
  currentUser: any;
  loggedInUserDetails!: loggedInUserViewModel;
  profileImage = '';
  currentMinutes = '';
  isMinutesDisplay = true;
  existingRoleSelected:any;
  protected readonly APP_CONSTANTS = APP_CONSTANTS;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WA_IS_E2E) private readonly isE2E: boolean,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private spinerService:SpinnerService,
    private rightSidebarService: RightSidebarService,
    private commonToastService:CommonToastService,
    private configService: ConfigService, private toastr: ToastrService,
    private authService: AuthService, private spinnerService: SpinnerService, private commonService: CommonService,
    private router: Router, private _formBuilder: FormBuilder, private userService: UserManagementService,
    public languageService: LanguageService,
    private showManagementService: ShowManagementService) {
    //this.currentValue = this.authService.timeDisplays;

    this.authService.timeDisplays.subscribe((result) => {
      this.currentValue = result;
      if (result == '02:0') {
        this.isMinutesDisplay=false;
      }
    });
    this.authService.displayMinutes.subscribe((result) => {
      this.currentMinutes = result;
    })
    this.commonService.loggedInUserDetails$.subscribe((user: loggedInUserViewModel) => {
      if (!!user) {
        this.loggedInUserDetails = user;
        const checkIfExisting = this.loggedInUserDetails.userRoles?.find(r=>r.isDefaultRole == true);
        if(this.commonService.isNotNULLEmptyUndefind(checkIfExisting)) {
            this.existingRoleSelected = checkIfExisting;
        }
        if (this.loggedInUserDetails.profilePicBase64 != null) {
          this.profileImage = 'data:image/png;base64,' + this.loggedInUserDetails.profilePicBase64;
        }
        else {
          this.profileImage = "assets/images/empty-profile.png";
        }
      }
    });
  }


  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en-US' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de-DE' },
  ];

  ngOnInit() {
    this.currentUser = new BehaviorSubject<UserLoginReponse>(JSON.parse(localStorage.getItem('currentUser') || '{}'));

    this.config = this.configService.configData;
    this.langStoreValue = this.currentUser?._value?.culture;
    const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.defaultFlag = 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
    this.initForm();
    //this.GetLoggedInUserDetails();
  }
  initForm() {
    this.resetPasswordForm = this._formBuilder.group({
      password: ['', [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
      confirmPassword: ['', Validators.required],
    },
      { validator: this.passwordMatchValidator });

  }

  ngAfterViewInit() {
    if (localStorage.getItem('theme')) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('theme') as string
      );
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem('menuOption')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('menuOption') as string
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        this.config.layout.sidebar.backgroundColor + '-sidebar'
      );
    }

    if (localStorage.getItem('sidebar_status')) {
      if (localStorage.getItem('sidebar_status') === 'close') {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      } else {
        this.renderer.removeClass(this.document.body, 'side-closed');
        this.renderer.removeClass(this.document.body, 'submenu-closed');
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      }
    }
  }
  callFullscreen() {
    if (!this.isFullScreen) {
      this.docElement?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    this.isFullScreen = !this.isFullScreen;
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    this.languageService.setLanguage(lang);
  }
  mobileMenuSidebarOpen(event: Event, className: string) {
    if (window.innerWidth < 1025) {
      const hasClass = (event.target as HTMLInputElement).classList.contains(
        className
      );
      if (hasClass) {
        this.renderer.removeClass(this.document.body, className);
        this.renderer.addClass(this.document.body, 'sidebar-gone');
      } else {
        this.renderer.addClass(this.document.body, className);
        this.renderer.removeClass(this.document.body, 'sidebar-gone');
      }
    } else {
      const hasClass = this.document.body.classList.contains('side-closed');
      if (hasClass) {
        this.renderer.removeClass(this.document.body, 'side-closed');
        this.renderer.removeClass(this.document.body, 'submenu-closed');
      } else {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      }
    }
  }
  public toggleRightSidebar(): void {
    this.rightSidebarService.sidebarState.subscribe((isRunning) => {
      this.isOpenSidebar = isRunning;
    });

    this.rightSidebarService.setRightSidebar(
      (this.isOpenSidebar = !this.isOpenSidebar)
    );
  }
  passwordMatchValidator(form: FormGroup) {
    const password = form?.get('password')?.value;
    const confirmPassword = form?.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

  openchangePasswordDialog() {
    this.isChangePasswordDialog = true;
  }
  closechangePasswordDialog() {
    this.isChangePasswordDialog = false;
  }

  changePassword(formData: any) {
    if (this.resetPasswordForm.invalid) {
      return;
    }
    this.spinnerService.show();
    this.isChangePasswordDialog = false;
    const payload = {
      "Password": formData.confirmPassword
    }
    this.userService.ResetPassword(payload).subscribe(
      (res: any) => {
        if (res.success) {
          this.logout();
          this.spinnerService.hide();
          this.toastr.success('Success', res.message, {
            progressBar: true,
            closeButton: true,
            timeOut: 10000
          });
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.toastr.error('error', error, {
          progressBar: true,
          closeButton: true,
          timeOut: 10000
        });
      });
  }
  GetLoggedInUserDetails() {
    this.commonService.GetLoggedInUserDetails();
  }
  navigateToUserProfile() {
    this.router.navigate(["/user-profile"]);
  }
  logout() {
    this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(['/auth/signin']);
      }
    });
  }
  switchRole(userRole:userRoleDTO) {
    if(this.commonService.isNotNULLEmptyUndefind(userRole)) {
      if(userRole.roleKey !== localStorage.getItem('roleKey')) {
        this.spinerService.show();
        const uRoleDTO: switchRoleReq = {
          userId: this.currentUser?._value?.userId,
          selectedUserRoleId:userRole.userRoleId
        }
        this.userService.switchRole(uRoleDTO).subscribe({
          next:(res: switchRoleResponse) => {
            if (res != null && res != undefined) {
              if(res.success) {
                localStorage.removeItem('modules');
                localStorage.setItem('token', res.data);
                localStorage.setItem('roleKey', res.roleKey);
                localStorage.setItem('roleDisplayName', res.roleDisplayName);
                this.commonToastService.showToasterMessage(res.msgCategoryKey,res.msgCategoryTitle, res.message);
                this.router.navigate(['user-profile']);
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
             //   this.GetLoggedInUserDetails();
              }
            }
          },
          error: (error) => {
            this.spinerService.hide();
            if (error.status !== 401) {
              this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR,MESSAGE_CATEGORY_CONSTATNS.USER, error);
            }
          }
        });
      }
    }
  }

  downloadPrintClient(){
    const exePath = 'assets/WCPPExe/wcpp-5.0.20.127-win.exe';
    const dmgPath = 'assets/WCPPExe/wcpp-5.0.20.711-intel-x86_64-macosx.dmg';
  
    if (this.getOS() === 'windows') {
      const popUp = window.open(exePath, '_blank');
      if (popUp == null || typeof (popUp) == 'undefined') {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR,MESSAGE_CATEGORY_CONSTATNS.USER, MESSAGE_CONSTATNS.DISABLE_POPUP_BLOCKER);
        }
    }
    else if (this.getOS() === 'macos') {
        const popUp = window.open(dmgPath, '_blank');
        if (popUp == null || typeof (popUp) == 'undefined') {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR,MESSAGE_CATEGORY_CONSTATNS.USER, MESSAGE_CONSTATNS.DISABLE_POPUP_BLOCKER);
        }
    }
    }

  getOS() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const  macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i;
    const windowsPlatforms = /(win32|win64|windows|wince)/i;
    const iosPlatforms = /(iphone|ipad|ipod)/i;
    let os = null;
  
    if (macosPlatforms.test(userAgent)) {
      os = "macos";
    } else if (iosPlatforms.test(userAgent)) {
      os = "ios";
    } else if (windowsPlatforms.test(userAgent)) {
      os = "windows";
    } else if (/android/.test(userAgent)) {
      os = "android";
    } else if (!os && /linux/.test(userAgent)) {
      os = "linux";
    }
  
    return os;
  }

  DownloadDocument() {
    this.spinnerService.show();
    console.log('download PDF');
    this.showManagementService.getSamplePDF().subscribe({
      next: (response) => {
        if(this.commonService.isNotNULLEmptyUndefind(response)) {
          const newBlob = new Blob([response]);
          const data = window.URL.createObjectURL(newBlob);
          const link = document.createElement("a");
          link.href = data;
          link.download = 'bing.pdf'; // set a name for the file
          link.click();
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.INFO, "PDF Integration", MESSAGE_CONSTATNS.SAMPLE_PDF);
          this.spinnerService.hide();
        }else {
           this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR,MESSAGE_CATEGORY_CONSTATNS.WEEKLY_MEETING, MESSAGE_CONSTATNS.FILE_DOWNLOAD_ISSUE);
           this.spinnerService.hide();
        }
        this.spinnerService.hide();
      },
      error: (error: any) => {
        this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR,MESSAGE_CATEGORY_CONSTATNS.WEEKLY_MEETING, error);
        this.spinnerService.hide();
      },
    });
  }

  get sortedUserRoles() {
    return this.loggedInUserDetails?.userRoles?.sort((a, b) => a.roleDisplayName.localeCompare(b.roleDisplayName)) || [];
  }
}
